/*
 * @Author: 范向玲
 * @Date: 2022-12-08 14:05:44
 * @LastEditors: 范向玲
 * @LastEditTime: 2023-01-09 14:05:44
 * @Description: 海外推介项目-数据管理表格配置
 * @FilePath: \src\components\DataManagement\management\tableConfig.js
*/
const tableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  {
    title: '项目照片',
    dataIndex: 'imgUrl',
    slots: { customRender: 'imgUrl', },
    ellipsis: true,
    align: 'center',
  },
  {
    title: '项目名称',
    dataIndex: 'propName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '国家',
    dataIndex: 'countryName',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '省份',
    dataIndex: 'stateProvince',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '全部矿种',
    dataIndex: 'commoditiesList',
    slots: { customRender: 'commoditiesList', },
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '矿权类型',
    dataIndex: 'claimType',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '股权结构',
    dataIndex: 'ownerList',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  {
    title: '发展阶段',
    dataIndex: 'devStage',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '资源量',
    dataIndex: 'resourceInfoList',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'resourceInfoList', },
  },
  {
    title: '开采方式',
    dataIndex: 'mineType',
    ellipsis: true,
    align: 'center',
    // width: 100,
  },
  // {
  //   title: '去年产量',
  //   dataIndex: 'productInfoList',
  //   ellipsis: true,
  //   align: 'center',
  //   slots: { customRender: 'productInfoList', },
  //   // width: 200,
  // },
  // {
  //   title: '设计或实际开始年限',
  //   dataIndex: 'startUpYear',
  //   ellipsis: true,
  //   align: 'center',
  // },
  // {
  //   title: '设计或实际闭坑年限',
  //   dataIndex: 'closureYear',
  //   ellipsis: true,
  //   align: 'center',
  //   // width: 100,
  // },
  {
    title: '项目类型',
    dataIndex: 'claimType',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '交易类型',
    dataIndex: 'dealType',
    ellipsis: true,
    align: 'center',
    // width: 200,
  },
  {
    title: '资产成本',
    dataIndex: 'amtCapitalInvested',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'amtCapitalInvested', },
    // width: 200,
  },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    width: 150,
  },
];

export { tableConfig, };
